var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4062 60.694C34.4013 66.7145 19.402 64.7163 9.38495 54.6992C-3.12832 42.186 -3.12832 21.8981 9.38495 9.38491C21.8982 -3.1283 42.1862 -3.1283 54.6995 9.38491C64.7167 19.4021 66.7149 34.4016 60.694 46.4064C61.2693 46.7818 61.8142 47.2216 62.3186 47.726L77.0332 62.4405C81.0293 66.4365 80.9684 72.9763 76.9723 76.9724C72.9762 80.9684 66.4365 81.0293 62.4404 77.0332L47.7258 62.3187C47.2214 61.8143 46.7816 61.2693 46.4062 60.694ZM19.9912 44.0931C13.3356 37.4375 13.3356 26.6467 19.9912 19.9911C26.6468 13.3355 37.4377 13.3355 44.0933 19.9911C50.7489 26.6467 50.7489 37.4375 44.0933 44.0931C37.4377 50.7486 26.6468 50.7486 19.9912 44.0931Z",
    fill: "currentcolor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.5adf6c16769c17c8b358b7a9334b5c3f.svg";
export { ForwardRef as ReactComponent };